import React from "react"

import Select from "react-select"

type MicrophoneOption = {
  label: string
  value: string
}

type MicrophoneSelectProps = {
  audioInputDevices: MediaDeviceInfo[]
  selectedAudioInputDeviceId: string
  setSelectedAudioInputDeviceId: (deviceId: string) => void
  disabled: boolean
  menuPortalTarget?: any
}

const MicrophoneSelect: React.FC<MicrophoneSelectProps> = ({
  audioInputDevices,
  selectedAudioInputDeviceId,
  setSelectedAudioInputDeviceId,
  disabled,
  ...rest
}) => {
  const options: MicrophoneOption[] = audioInputDevices.map(
    (device, index) => ({
      label: device.label || `Microphone ${index + 1}`,
      value: device.deviceId,
    })
  )

  return (
    <Select
      inputId="audio-input-device"
      className="text-black"
      options={options}
      value={
        options.find(option => option.value === selectedAudioInputDeviceId) ||
        null
      }
      onChange={option => {
        if (option) setSelectedAudioInputDeviceId(option.value)
      }}
      isClearable={false}
      isSearchable={false}
      isDisabled={disabled}
      {...rest}
    />
  )
}

export default MicrophoneSelect
